(function (window, angular, undefined) {
    angular.module('formApp')
        .directive("rateRaid", [function () {
            return {
                restrict: "A",
                link: function ($scope, element, ctrl, ngModel) {
                    var elements = ['pettype-petTypeDog[0]', 'pettype-petTypeCat[0]', 'pettype-petTypeRabbit[0]', 'continueBtn'];
                        if (window.location.hostname === 'quote.petplan.co.uk') {
                        angular.element(document).ready(function () {

                            // Wrap in a div to break finding by XPath
                            for (var j = 0, lenTwo = elements.length; j < lenTwo; j++) {
                                if(document.getElementById('continueBtn')){
                                    var currentElTwo = document.getElementById('continueBtn');
                                    var wrapper = document.createElement('span');
                                    wrapper.classList.add('wrapper' + Math.floor(Math.random() * (200 - 1 + 1)) + 1);
                                    currentElTwo.parentNode.insertBefore(wrapper, currentElTwo);
                                    wrapper.appendChild(currentElTwo);
                                }
                            }
                            //Randomise ids to break finding by ID
                            for (var i = 0, len = elements.length; i < len; i++) {
                                if(document.getElementById('' + elements[i] + '')){
                                    var currentEl = document.getElementById('' + elements[i] + '');
                                    var randomArr = elements[i].split('');
                                    var newStr = randomArr.sort(
                                        function () {
                                            return 0.5 - Math.random();
                                        }).join('');
                                        if(currentEl.parentNode.classList.contains('radio-group')){
                                            currentEl.parentNode.setAttribute("for", newStr); 
                                        }
                                    currentEl.id = newStr;
                                }
                            }
                        });
                    }
                }
    
            };
        }]);
})(window, window.angular);